import { api } from "@/api/client";

export enum LoginMethod {
  Basic,
  Azure,
}

export type LoginConfiguration =
  | {
      loginMethod: LoginMethod.Basic;
    }
  | {
      loginMethod: LoginMethod.Azure;
      azure: AzureConfiguration;
    };

export type AzureConfiguration = {
  clientId: string;
  scopes: string[];
  authority: string;
  knownAuthorities: string[];
};

export type Configuration = {
  currentUser: string;
  version: string;
  projectName?: string;
  subProjectName?: string;
  datasheetName?: string;
  rbiWelderMultipleWelds: boolean;
  rbiWeldLimit: number;
  coordinator?: ConfigurationCoordinator;
  qualifier?: ConfigurationQualifier;
};

export type ConfigurationQualifier = {
  isWilliams: boolean;
};

export type ConfigurationCoordinator = {
  isInspector: boolean;
  isAep: boolean;
  isParalloy: boolean;
  isHitachi: boolean;
  isCDSEnergy: boolean;
};

export function getConfiguration() {
  return api.get<Configuration>("configurations");
}

export function getLoginConfiguration() {
  return api.get<LoginConfiguration>("configurations/login");
}
